import React, { useState } from "react";

import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

import {
    createStyles,
    Text,
    Avatar,
    TypographyStylesProvider,
    Paper,
    ActionIcon,
    Image,
    Group,
    Card,
    Button,
    NumberInput,
    Accordion,
    Checkbox
} from '@mantine/core';

import {
    IconFlag,
    IconCornerDownRight,
    IconSquareRoundedArrowUp,
    IconTrendingUp,
    IconCheck,
    IconX
} from '@tabler/icons';

import pagani from '../assets/pagani.jpg';

const useStyles = createStyles((theme) => ({
    msg: {
        textAlign: 'center'
    }
}));


//needed:doc only a message property is needed
/*
 * FLOW
 * accordian
 * */
export function AlertMeCard({message}){
    const { classes } = useStyles();
    const [wrapChecked, setWrapChecked] = useState(false);
    const [newBidChecked, setNewBidChecked] = useState(false);
    const [updateChecked, setUpdateChecked] = useState(false);

    return (
        <>
            <Card shadow="sm" p="lg" radius="md">
                <Card.Section>
                    <Accordion
                        transitionDuration={0}
                        disableChevronRotation={true}
                        defaultValue=""
                    >
                        <Accordion.Item value="wrapup">
                            <Accordion.Control
                                chevron={<Checkbox checked={wrapChecked} onChange={(event) => setWrapChecked(event.currentTarget.checked)} />}
                            >Wrap-Up</Accordion.Control>
                            <Accordion.Panel>Alert Me when 30 mins remain in the auction</Accordion.Panel>
                        </Accordion.Item>
                        <Accordion.Item value="newbid">
                            <Accordion.Control
                                chevron={<Checkbox checked={newBidChecked} onChange={(event) => setNewBidChecked(event.currentTarget.checked)} />}
                            >New Bid</Accordion.Control>
                            <Accordion.Panel>Alert Me when there is a new bid on the current item</Accordion.Panel>
                        </Accordion.Item>
                        <Accordion.Item value="Update">
                            <Accordion.Control
                                chevron={<Checkbox checked={updateChecked} onChange={(event) => setUpdateChecked(event.currentTarget.checked)} />}
                            >Listing Update</Accordion.Control>
                            <Accordion.Panel>Alert Me details or media pertaining to this listing are updated</Accordion.Panel>
                        </Accordion.Item>
                    
                    
                    </Accordion>
                
                </Card.Section>
                <br/>
                <br/>
                <Button
                    color="green"
                    leftIcon={<IconCheck size={35} stroke={2.0}/>}
                    fullWidth
                ></Button>
            </Card>
        </>
    )
}

